export default {
      id: "arrows-alt-h-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#arrows-alt-h",
      toString: function () {
        return this.url;
      }
    }